"use strict";

var Common            = require( "../Common" );
var CommonGame        = require( "../CommonGame" );


//===================================================
//
// Constructor
//
//===================================================

/**
 * @constructor
 */
function MagicPencil() 
{
	// Constants.
	this.LINE_THICKNESS = 5;

	
	// Attributes.
	this._drawLayer = null;
	this._textureId = null;
}
module.exports               		= MagicPencil;
MagicPencil.prototype.constructor 	= MagicPencil;


//===================================================
//
// Public
//
//===================================================

MagicPencil.prototype.init = function( drawLayer ) 
{	
	this._drawLayer = drawLayer;		
};


//===================================================
//
// Private
//
//===================================================

MagicPencil.prototype._draw = function( from, to ) 
{  
	this._drawLayer.context.beginPath();
	this._drawLayer.context.moveTo( from.x, from.y );
	this._drawLayer.context.lineTo( to.x, to.y );
	this._drawLayer.context.stroke();

	this._drawLayer.onContext_Changed();
};

MagicPencil.prototype._createPattern = function() 
{  
	var patternCanvas = document.createElement( 'canvas' );
	var ctx = patternCanvas.getContext( '2d' );
	var texture = Common.assets.getTexture( this._textureId );
	var frame = texture.frame;
	patternCanvas.width = patternCanvas.height = frame.width;
	
	ctx.drawImage( texture.baseTexture.source, frame.x, frame.y, frame.width, frame.height, 0, 0, frame.width, frame.height );
	
	return ctx.createPattern( patternCanvas, 'repeat' );
};


//===================================================
//
// Events
//
//===================================================

MagicPencil.prototype.onDrawBegan = function( point ) 
{  
	this._drawLayer.context.lineWidth = this.LINE_THICKNESS;
	this._drawLayer.context.lineJoin = this._drawLayer.context.lineCap = 'round';
	this._drawLayer.context.strokeStyle = this._createPattern();
	
	this._draw( point, point );
};

MagicPencil.prototype.onDrawMoved = function( from, to ) 
{  
	this._draw( from, to );
};

MagicPencil.prototype.onDrawEnded = function() {};


//===================================================
//
// Getters / Setters
//
//===================================================

Object.defineProperty(
	MagicPencil.prototype, 
	"textureId", 
	{ set: function( a ) { this._textureId = a; } } );